import axiosInstance from 'helpers/axiosInstance';
import {
  WORKSHOP_PHOTOS_BY_WORKSHOP,
  WORKSHOP_PHOTOS_UPLOAD,
  WORKSHOP_PHOTOS_DELETE,
  WORKSHOP_PHOTOS_GET,
} from 'constants/api';
import { WorkshopPhoto, WorkshopPhotoUploadResponse, WorkshopPhotoDeleteResponse } from 'models/WorkshopPhotos';

export const getWorkshopPhotos = async (workshopId: string): Promise<WorkshopPhoto[]> => {
  const response = await axiosInstance.get<WorkshopPhoto[]>(
    WORKSHOP_PHOTOS_BY_WORKSHOP(workshopId)
  );
  return response.data;
};

export const uploadWorkshopPhotos = async (
  workshopId: string,
  files: File[]
): Promise<WorkshopPhotoUploadResponse> => {
  const formData = new FormData();
  
  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await axiosInstance.post<WorkshopPhotoUploadResponse>(
    `${WORKSHOP_PHOTOS_UPLOAD}?workshopId=${workshopId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  
  return response.data;
};

export const deleteWorkshopPhoto = async (photoId: string): Promise<WorkshopPhotoDeleteResponse> => {
  const response = await axiosInstance.delete<WorkshopPhotoDeleteResponse>(
    WORKSHOP_PHOTOS_DELETE(photoId)
  );
  return response.data;
};

export const getWorkshopPhotoById = async (photoId: string): Promise<WorkshopPhoto> => {
  const response = await axiosInstance.get<WorkshopPhoto>(
    WORKSHOP_PHOTOS_GET(photoId)
  );
  return response.data;
};

